import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ValidationMessageCCField = ({
  validationErrors
}) => {
  switch (true) {
    case validationErrors.cc.invalidEmails:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.sendInvoiceModal.fields.cc.validationMessage.email"
      });
    case validationErrors.tooManyContacts:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.sendInvoiceModal.fields.all.validationMessage.max"
      });
    default:
      return null;
  }
};
export default ValidationMessageCCField;